<app-spinner></app-spinner>
<div class="page-container">
    <header class="header" style="position: relative">
        <div class="title">
            <!--      <img src="./assets/images/logo/logo-immoconn.svg" />-->
            <!--      <span>{{ applicationTitle }}</span>-->
            <span class="pointer" (click)="onGetSerialNumberClicked()">
                {{ gatewayId ? gatewayId : 'JUCxxxxxxxx' }}
            </span>
            <span class="small">
                {{ shareService.simIp ? shareService.simIp : 'xxx xxx xxx xxx' }}
                | {{ shareService.version ? shareService.version : 'x.x.x' }}
                <span *ngIf="shareService.debugMode">
                     <span class="debugButton" (click)="onSaveDebugDataClick()">M</span>
                     <span class="debugButton" (click)="onLoadDebugDataClick()">L</span>
                     <span class="debugButton" (click)="onClearDebugDataClick()">C</span>
                 </span>
            </span>

        </div>

        <div class="signal noselect"
             (click)="onRefreshSignalQualityClicked()"
             [ngClass]="{ 'no-gateway-id': !gatewayId }">

            <img *ngIf="shareService.signalQuality && +shareService.signalQuality > 0"
                 src="./assets/images/icons/icon-status-positive.svg"/>
            <div class="refresh" *ngIf="!shareService.signalQuality">
                <img src="./assets/images/icons/refresh.svg"/>
            </div>
            <span>Signal: <span *ngIf="shareService.signalQuality">{{ shareService.signalQuality }}</span> <span
                    *ngIf="shareService.radioType"> {{ shareService.radioType }}</span>
            </span>
        </div>

        <div class="icon-container">

            <div *ngIf="!autoSaveService.dataSuccessfullySaved" class="auto-save-warning">
                <img class="title-icon" src="./assets/images/icons/save.svg"/>
            </div>
            <div class="signal noselect"
                 *ngIf="shareService.signalQuality"
                 (click)="onGetRawDataClicked()"
                 [ngClass]="{ 'no-gateway-id': !gatewayId }">
                <img class="title-icon" src="./assets/images/icons/icon-heated-gw.svg"/>
            </div>
        </div>

        <div fxLayout="column" class="button-wrapper mt-24" fxLayoutAlign="end end">
            <button class="legend-btn" fxLayoutAlign="center center" style="width: auto" (click)="showMenu = !showMenu">
                <i class="ju ju-hamburger_menu"></i>
            </button>

            <div class="menu-modal" *ngIf="showMenu">
                <div class="rows">
                    <div class="row" fxLayoutAlign="start center" [routerLink]="['/gateway']">
                        Installation App
                    </div>
                    <div *ngIf="canAccessPlannerTool()" class="row" fxLayoutAlign="start center"
                         [routerLink]="['/planner']">
                        Planungsfunktion
                    </div>
                    <div class="row" fxLayoutAlign="start center" (click)="openOwnPasswordPopup()">
                        Passwort ändern
                    </div>
                    <div class="row" fxLayoutAlign="start center" [routerLink]="['/login']">
                        Logout
                    </div>
                </div>
            </div>
        </div>

    </header>

    <div class="menu-container">
        <button type="button" class="menu-item noselect"
                routerLink="general" routerLinkActive="active"
                [class]="getGeneralComponentStepClass()"
                [style]="getGeneralComponentStepStyle()">
            <div class="icon-box" fxLayoutAlign="center center">
                <img src="./assets/images/icons/icon-heated-house.svg"/>
                <i class="ju-check"></i>
            </div>
            <div>Montage</div>
        </button>

        <button type="button" class="menu-item noselect"
                routerLink="building" routerLinkActive="active"
                [class]="getBuildingComponentStepClass()"
                [style]="getBuildingComponentStepStyle()">
            <div class="icon-box" fxLayoutAlign="center center">
                <img src="./assets/images/icons/icon-heated-house.svg"/>
                <i class="ju-check"></i>
            </div>
            <div>Gebäude</div>
        </button>

        <button type="button" class="menu-item noselect"
                routerLink="heating" routerLinkActive="active"
                [class]="getHeatingComponentStepClass()"
                [style]="getHeatingComponentStepStyle()">
            <div class="icon-box" fxLayoutAlign="center center">
                <img src="./assets/images/icons/icon-heated-heating.svg"/>
                <i class="ju-check"></i>
            </div>
            <div>Heizung</div>
        </button>

        <button type="button" class="menu-item noselect"
                routerLink="sensors" routerLinkActive="active"
                [class]="getSensorsComponentStepClass()"
                [style]="getSensorsComponentStepStyle()">
            <div class="icon-box" fxLayoutAlign="center center">
                <img src="./assets/images/icons/icon-heated-gw.svg"/>
                <i class="ju-check"></i>
            </div>
            <div>Sensoren</div>
        </button>

        <button type="button" class="menu-item noselect"
                routerLink="photos" routerLinkActive="active"
                [ngClass]="getPhotosComponentStepClass()"
                [style]="getPhotosComponentStepStyle()">
            <div class="icon-box" fxLayoutAlign="center center">
                <img src="./assets/images/icons/icon-photos.svg"/>
                <i class="ju-check"></i>
            </div>
            <div>Fotos</div>
        </button>
    </div>

    <div class="image-cache-container">
        <!--        used to cache pictures for all pages to work in offline mode-->
        <img src="./assets/images/icons/icon-upload-picture.svg"/>
        <img src="./assets/images/icons/refresh.svg"/>
        <img src="./assets/images/icons/icon-switch-on.svg"/>
        <img src="./assets/images/icons/icon-switch-off.svg"/>
        <img src="./assets/images/icons/icon-heated-heating.svg"/>
    </div>

    <router-outlet></router-outlet>

    <div class="info-wrapper">
        <span class="footer-text">{{ applicationTitle }} (v3.01)</span>
    </div>
</div>
